import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsOneStep.PersonRowControls', {
    edit: 'Edit',
    remove: 'Remove',
    removeUser: 'Remove user',
    youAreAboutToRemove: 'You are removing {role} whose verification data has been requested',
    afterDeleting:
        'After deleting this user you will need to provide verification details for one of the existing director or add a new one',
    areYouSure: 'Are you sure you want to remove this user?',
});
